import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@material-ui/core";
import * as api from "../forecastApi";

export default function BrandSelect({ value, onChange }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    setLoading(true);
    api
      .fetchBrandValues(ctrl.signal)
      .then((res) => {
        if (res && res.status) {
          setOptions(res.data || []);
        }
      })
      .catch(() => { })
      .finally(() => setLoading(false));
    return () => ctrl.abort();
  }, []);

  return (
    <FormControl fullWidth>
      <InputLabel shrink >
        Select Brand <span style={{ color: "red" }}>*</span>
      </InputLabel>
      <Select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        displayEmpty
      >
        <MenuItem value="" disabled>
          {loading ? <CircularProgress size={16} /> : "Select Brand"}
        </MenuItem>
        {options.map((o, i) => (
          <MenuItem key={`${o.brand}-${i}`} value={o.brand}>
            {o.brand}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
